/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import { useInitialize } from '@views/composables/use-initialize';

type UserAppType = {
  isInitialized: boolean;
};

const initialState = (): UserAppType => ({
  isInitialized: false,
});

export const useUserAppStore = defineStore({
  id: 'user-app',
  state: initialState,
  actions: {
    $reset() {
      Object.assign(this, initialState());
    },
    async initialize(): Promise<void> {
      if (this.isInitialized) return;

      const { initializeUserApp } = useInitialize();
      try {
        await initializeUserApp();
        this.isInitialized = await true;
      } catch (error) {
        console.error(error);
      }
    },
  },
});
